import { digitsEnToFa } from 'persian-tools2';
import { useDoctorInfo } from 'modules/user/hooks/useDoctorInfo';
import styled from 'styled-components';

export const NotificationBadge = () => {
  const { data: userInfo, isFetching, isLoading } = useDoctorInfo();
  const count = userInfo?.unseenNotificationCount;

  if (count < 1 || isFetching || isLoading) return null;

  return (
    <StyledNotifBadge kry={`notif-count=${count}`}>
      <p>{+count > 99 ? digitsEnToFa('+99') : digitsEnToFa(count)}</p>
    </StyledNotifBadge>
  );
};

const StyledNotifBadge = styled.div`
  min-height: 16px;
  min-width: 16px;
  position: absolute;
  top: -3px;
  left: 15px;
  p {
    padding: 1px 2px 1px;
    border-radius: 50px;
    background: #d81d5d;
    font-size: 10px;
    color: white;
    font-family: 'dana-bold';
    height: 100%;
    width: 100%;
    display: grid;
    place-items: center;
  }
`;
